import * as React from "react";
import { useEffect, useState, useContext } from "react";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "./App.css";
import { TbMovie } from "react-icons/tb";
import Paper from "@mui/material/Paper";
import Modal from "@mui/material/Modal";
import PointImg from "./PointImg";
import ExchangeImg from "./ExchangeImg";
import SuccessImg from "./SuccessImg";
import Alert1 from "./Alert1";
import LoadingImg1 from "./LoadingImg1";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

const pointList = [
  { id: 100, name: "100ポイント" },
  { id: 200, name: "200ポイント" },
  { id: 300, name: "300ポイント" },
  { id: 400, name: "400ポイント" },
  { id: 500, name: "500ポイント" },
  { id: 600, name: "600ポイント" },
  { id: 700, name: "700ポイント" },
  { id: 800, name: "800ポイント" },
  { id: 900, name: "900ポイント" },
  { id: 1000, name: "1000ポイント" },
];
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60vw",
  boxShadow: 24,
  p: 4,
};

const modalStyle1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  boxShadow: 24,
};

const modalStyle2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  boxShadow: 24,
  p: 4,
};

function PointEx(props) {
  const [exPoint, setExPoint] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(false);
  const [pointExModal, setPointExModal] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const headers = {
    "Content-Type": "application/json",
    //Authorization: `Bearer ${authToken}`
  };
  //console.log(props);

  const touchHandler = (event) => {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  };
  document.addEventListener("touchstart", touchHandler, {
    passive: false,
  });

  const handlePointExModalOpen = () => {
    setExPoint("");
    setSuccess("");
    setError("");
    setPointExModal(true);
  };
  const handlePointExModalClose = () => {
    setIsLoading1(false);
    setExPoint("");
    setSuccess("");
    setError("");
    setPointExModal(false);
  };

  const handleSuccessModalClose = () => {
    props.getHistory();
    setExPoint("");
    setSuccess("");
    setError("");
    window.location.reload();
  };

  const handleErrorModalClose = () => {
    setExPoint("");
    setSuccess("");
    setError("");
  };

  const pointEx = () => {
    setIsLoading1(true);
    const addPoint = {
      addPoint: exPoint,
      userId: props.findoutUserId,
      poinExUserId: props.pointExUserId,
    };
    const addExPoint = {
      user_id: props.pointExUserId,
      point: exPoint,
    };
    const deleteExPoint = {
      user_id: props.pointExUserId,
      point: -exPoint,
    };
    const deletePoint = {
      addPoint: -exPoint,
      userId: props.findoutUserId,
      poinExUserId: props.pointExUserId,
    };
    axios
      .post(
        "https://asia-northeast1-findout-app-7f46a.cloudfunctions.net/pointEx/addPoints",
        addPoint,
        { headers: headers }
      )
      .then((response) => {
        axios
          .post(
            "https://us-central1-point-ex-9709a.cloudfunctions.net/pointex/editPoints",
            deleteExPoint,
            { headers: headers }
          )
          .then((response) => {
            setSuccess("ポイントを交換しました");
            setIsLoading1(false);
          })
          .catch((error) => {
            axios.post(
              "https://asia-northeast1-findout-app-7f46a.cloudfunctions.net/pointEx/addPoints",
              deletePoint,
              { headers: headers }
            );
            setError("交換できませんでした");
            setIsLoading1(false);
          });
      })
      .catch((error) => {
        setError("交換できませんでした");
        setIsLoading1(false);
      });
  };

  //console.log(pointList.filter((e) => e.id < props.point));
  return (
    <>
      {props.point > 100 ? (
        <Grid width={"80%"}>
          <Button
            variant="contained"
            fullWidth
            color="success"
            onClick={() => {
              handlePointExModalOpen();
            }}
          >
            ポイント交換する
          </Button>
        </Grid>
      ) : (
        <Grid width={"80%"}>
          <Button
            variant="contained"
            fullWidth
            disabled
            color="success"
            onClick={() => {
              handlePointExModalOpen();
            }}
          >
            ポイント交換する
          </Button>
        </Grid>
      )}

      <Modal
        hideBackdrop
        open={pointExModal}
        aria-labelledby="title"
        aria-describedby="description"
      >
        <Paper sx={{ ...modalStyle1 }}>
          <Grid container direction="column" alignItems="center">
            <Modal
              hideBackdrop
              open={isLoading1}
              aria-labelledby="title"
              aria-describedby="description"
            >
              <Paper sx={{ ...modalStyle }}>
                <LoadingImg1 />
              </Paper>
            </Modal>
            <Modal
              hideBackdrop
              open={success !== ""}
              aria-labelledby="title"
              aria-describedby="description"
            >
              <Paper sx={{ ...modalStyle2 }}>
                <SuccessImg />
                <Grid container direction="column" alignItems="center">
                  <Typography variant="h6" color="success">
                    {success}
                  </Typography>
                  <Button
                    sx={{ marginTop: 3 }}
                    variant="contained"
                    fullWidth
                    color="error"
                    onClick={() => {
                      handleSuccessModalClose();
                    }}
                  >
                    とじる
                  </Button>
                </Grid>
              </Paper>
            </Modal>
            <Modal
              hideBackdrop
              open={error !== ""}
              aria-labelledby="title"
              aria-describedby="description"
            >
              <Paper sx={{ ...modalStyle2 }}>
                <Alert1 />
                <Grid container direction="column" alignItems="center">
                  <Typography variant="subtitle1" color="error">
                    {error}
                  </Typography>
                  <Button
                    sx={{ marginTop: 3 }}
                    variant="contained"
                    fullWidth
                    color="error"
                    onClick={() => {
                      handleErrorModalClose();
                    }}
                  >
                    とじる
                  </Button>
                </Grid>
              </Paper>
            </Modal>
            <Typography variant="h6" sx={{ mt: 3 }}>
              findoutのポイントに交換
            </Typography>

            <Typography variant="h6" sx={{ mt: 3 }}>
              現在<b> {props.point} </b>ポイント
            </Typography>

            {/* {success && (
              <Typography variant="h6" color="success" sx={{ marginTop: 3 }}>
                {success}
              </Typography>
            )} */}
            {/* {error && (
              <Typography variant="h6" color="error" sx={{ marginTop: 3 }}>
                {error}
              </Typography>
            )} */}
            <FormControl sx={{ width: "80%", marginTop: 5 }}>
              <InputLabel id="point">交換するポイントを選択</InputLabel>
              <Select
                labelId="point"
                fullWidth
                label="交換するポイントを選択"
                value={exPoint}
                onChange={(e) => setExPoint(e.target.value)}
              >
                <MenuItem value="">交換するポイントを選択</MenuItem>
                {pointList
                  .filter((e) => e.id < props.point)
                  .map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>

            <Typography variant="subtitle1" sx={{ mt: 3 }}>
              ※交換は100ポイント単位となります
            </Typography>

            <Grid sx={{ width: "80%", marginTop: 5 }}>
              {props.point > 100 && exPoint !== "" ? (
                <Button
                  variant="contained"
                  fullWidth
                  color="success"
                  onClick={() => {
                    pointEx();
                  }}
                >
                  交換する
                </Button>
              ) : (
                <Button variant="contained" fullWidth disabled color="success">
                  交換する
                </Button>
              )}
            </Grid>
            <Grid sx={{ width: "80%", marginTop: 5 }}>
              <Button
                variant="contained"
                fullWidth
                color="error"
                onClick={() => {
                  handlePointExModalClose();
                }}
              >
                もどる
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    </>
  );
}
export default PointEx;
